import cn from 'classnames';
import Link from 'next/link';
import { useEffect, useRef } from 'react';
import Portal from 'react-scale/components/primitives/portal';
import { gsap } from 'gsap';

import s from './mobile-menu.module.css';

const MobileLink = ({ href, children, className, onClick = () => {} }) => (
  (<Link
    href={href}
    onClick={onClick}
    className={cn(className, 'text-[32px] opacity-0')}>

    {children}

  </Link>)
);

const MobileMenu = ({ isOn, handleToggle }) => {
  const linksContainerRef = useRef(null);

  useEffect(() => {
    if (!linksContainerRef.current) return;

    let tween;
    if (isOn) {
      tween = gsap.to(linksContainerRef.current.children, {
        autoAlpha: 1,
        stagger: 0.04,
        delay: 0.48,
        scaleY: 1
      });
    } else {
      tween = gsap.to(linksContainerRef.current.children, {
        autoAlpha: 0,
        scaleY: 0.95
      });
    }

    return () => {
      tween?.kill();
    };
  }, [isOn]);

  return (
    <>
      <div className={cn('flex items-center', { [s.menuOpen]: isOn })}>
        <button
          className={cn(
            s.menuButton,
            'w-16 h-16 -mr-6 rounded-xl relative overflow-hidden transition-colors',
            { 'text-white': isOn }
          )}
          onClick={handleToggle}
          type="button"
        >
          <svg
            className="absolute w-16 h-16 -translate-x-1/2 -translate-y-1/2 pointer-events-none left-1/2 top-1/2"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path className={s.line1} d="M0 70l28-28c2-2 2-2 7-2h64" />
            <path className={s.line2} d="M0 50h99" />
            <path className={s.line3} d="M0 30l28 28c2 2 2 2 7 2h64" />
          </svg>
        </button>
      </div>
      <Portal>
        <div
          className={cn('container fixed z-50 left-0 right-0 top-[64px]', {
            'bottom-0 bg-black visible': isOn,
            'bottom-full bg-black/60 pointer-events-none': !isOn
          })}
          style={{
            transition:
              'background .44s .2s cubic-bezier(0.52, 0.16, 0.24, 1), bottom .56s cubic-bezier(0.52, 0.16, 0.24, 1) .2s'
          }}
          aria-hidden={!isOn}
        >
          <div className="flex flex-col pt-8 space-y-4 text-white" ref={linksContainerRef}>
            <MobileLink onClick={handleToggle} href="/events/transformx/sponsorship">
              Sponsorship
            </MobileLink>
            <MobileLink onClick={handleToggle} href="/events/transformx/speakers">
              Speakers
            </MobileLink>
            <MobileLink onClick={handleToggle} href="/events/transformx/agenda">
              Agenda
            </MobileLink>
          </div>
        </div>
      </Portal>
    </>
  );
};

export default MobileMenu;
